function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: "21.6",
  cy: "21.6",
  r: "21.6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Meldedialog",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Meldung-1",
  transform: "translate(-296 -45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(296 45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button/map/exitfix"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-Button-Copy",
  strokeWidth: "1",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#545454",
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.041 14.783L14.856 28.968M29.041 28.968L14.856 14.783",
  id: "Path-17",
  stroke: "#FFF",
  strokeWidth: "2.7"
})))))));